import { Button, Popconfirm, Spin, Table, message } from "antd";
import Title from "antd/es/typography/Title";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthService } from "../../services/AuthService";
import LayoutContext from "../../context/layoutContext";
import { DeleteOutlined } from "@ant-design/icons";
import { UserContext } from "../../context/userContext";

const Stores = () => {
    const {  role: ROLE } = useContext(LayoutContext);

    const [messageApi, contextHolder] = message.useMessage();
  const {  user } = useContext(UserContext);
    
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);

    const [columns, setColumns] = useState([
        {
            title: 'Emri',
            dataIndex: 'storeName',
            key: 'storeName',
            width: 150, // Set the fixed width for the column
        },
        {
            title: 'Lokacioni',
            dataIndex: 'location',
            key: 'location',
        },
        ...(user?.details?.roleName === 'Admin' ? [{
            title: 'ACTIONS',
            dataIndex: 'actions',
            key: 'actions',
            width: 80,
            render: (_, record) => {
              return (
                <Popconfirm
                  title="Fshij piken shitese"
                  description="A jeni i sigurte per veprimin?"
                  okText="Po"
                  cancelText="Anulo"
                  onConfirm={() => deleteStore(record)}
                >
                  <Button type="primary" danger size="small"><DeleteOutlined /></Button>
                </Popconfirm>
              );
            },
          }] : [])
    ]);

    const getStores = async () => {
        setLoading(true);
        let res = await AuthService.getStores({});
        console.log("get stores", res);
        if(res && res.items && res.items.length > 0){
            setStores(res.items);
        }
        setLoading(false)
    }

    const deleteStore = async (store) => {
 
        
         
           if(!store?.storeId) return;
         
             let res = await AuthService.deleteStore(store?.storeId);
             console.log("deleted res", res);
             if(res){
               messageApi.open({
                 type: 'success',
                 content: 'Pika shitese u fshi me sukses!',
             });
             getStores();
             }
           
    }
    useEffect(()=>{
        getStores();
    }, [])


    return (
        <div className="container">
                 {contextHolder}
        <div className="d-flex justify-content-between align-items-center mb-2">
            <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Pikat shitese</Title>
            <Link to="/stores/new" style={{ display: "flex" }}>
                <Button type="primary">Shto një të ri</Button>
            </Link>
        </div>
        {stores && <Spin spinning={loading} tip="Duke procesuar te dhenat..."><Table dataSource={stores} size="small" columns={columns} style={{ marginTop: 20 }} /> </ Spin>}

    </div>
    )
}

export default Stores;